import React from 'react';

import { useHistory } from 'react-router-dom';

import { Messages } from '@vyce/core/src/modules/messagesModule/Messages';
import { ChatUser } from '@vyce/core/src/types';

import { useSubscriptionData } from '../../../modules/subscriptionInfoModule/hooks/useSubscriptionData';
import { ConfirmMessagingSubscriptionDialog } from './ConfirmMessagingSubscriptionDialog';

interface Props {
  chatUser: ChatUser;
  companyId: string;
  hadSubscription: boolean;
  hasSubscription: boolean;
  hasPermissions?: boolean;
  onActivated: () => void;
}

// Messages in restricted mode for companies without a messaging subscription:
// Vyce Notifications chat only + activation banner wired to the subscription flow
export const RestrictedMessages: React.FC<Props> = ({
  chatUser,
  companyId,
  hadSubscription,
  hasSubscription,
  hasPermissions,
  onActivated,
}) => {
  const history = useHistory();
  const {
    isMessagingSubscriptionDialogOpen,
    openMessagingSubscriptionDialog,
    closeMessagingSubscriptionDialog,
    addMessagingSubscription,
    loadingMessagingSubscription,
  } = useSubscriptionData();

  const handleActivateClick = () => {
    if (hadSubscription || !hasSubscription) {
      return history.push('/subscriptions?dialog=true');
    }
    openMessagingSubscriptionDialog();
  };

  const subscribeToMessaging = async () => {
    const success = await addMessagingSubscription();
    if (success) {
      onActivated();
    }
  };

  return (
    <>
      <Messages
        user={chatUser}
        companyId={companyId}
        route="/messages"
        restrictedMode
        launcherClearance
        canActivate={hasPermissions}
        onActivateClick={handleActivateClick}
      />

      <ConfirmMessagingSubscriptionDialog
        open={isMessagingSubscriptionDialogOpen}
        setOpen={closeMessagingSubscriptionDialog}
        confirmFunction={subscribeToMessaging}
        loading={loadingMessagingSubscription}
      />
    </>
  );
};
